import Cookies from "js-cookie";
import { useLayoutEffect, useState } from "react";
import api from "../../services/api";
import GeneralContext from "./GeneralContext";
import EModulePermissions from "../../enums/EModulePermissions"
import { displayMessage } from "../../services/helper";
// Mantem uma variável atualizada com as dimensoes da tela
const useWindowSize = () => {
    const [size, setSize] = useState([window.innerWidth, window.innerHeight])
  
    useLayoutEffect(() => {
  
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight])
      }
  
      window.addEventListener('resize', updateSize)
      updateSize();
      return () => window.removeEventListener('resize', updateSize)
  
    }, [])
  
    return size
  }


export default function GeneralContextProvider({children}) {


    const [windowWidth, windowHeight] = useWindowSize()

    const maxWidthMobileMode = 700 //px
    const minWidthMobileModeLandscape = 601
    const maxWidthMobileModeLandscape = 1024
  
    const mobile_mode = windowWidth <= maxWidthMobileMode
    const landscape_mobile = windowWidth >= minWidthMobileModeLandscape && windowWidth <= maxWidthMobileModeLandscape
  
  
    const [logged, setLogged] = useState(null)
    const [show_loading, setShowLoading] = useState(false)
    const [userPermissions, setUserPermissions] = useState([])
    const [isAdmin, setIsAdmin] = useState(true)
    const [user, setUser] = useState(null)
    const [enums, setEnums] = useState(null)
    const [interruptions, setInterruptions] = useState([])
    const [selectedLanguage, setSelectedLanguage] = useState(null)
    const [currentProtocol, setCurrentProtocol] = useState(null)

    
    function handleSetSelectedLanguage(code) {
      setSelectedLanguage(code)
      localStorage.setItem('language', code)
    }
  
    function setLoggedUser(loggedStatus) {
      if (!loggedStatus) {
        api.auth.removeAuthorizationToken()
        Cookies.remove('token')
        localStorage.removeItem('user')
      }
      setLogged(loggedStatus)
    }
  
    async function getUserPermissions() {
      try {
        const {data} = await api.permission.listUserUIPermissions()
        
        const hasAdminPermission = data.some(permission => (permission.permission_id == EModulePermissions.ADMIN.permission_id && permission.hasPermission ))
        
        setUserPermissions(data)
        setIsAdmin(hasAdminPermission)
  
      } catch (error) {
        console.error(displayMessage('ERROR_CHECK_PERMISSIONS'))
      }
    }

    return (
        <GeneralContext.Provider
        value={
            {
              logged,
              setLoggedUser,
              userPermissions,
              setUserPermissions,
              getUserPermissions,
              isAdmin,
              setIsAdmin,
              show_loading, setShowLoading,
              windowWidth, windowHeight,
              mobile_mode,
              landscape_mobile,
              user, setUser,
              enums, setEnums,
              interruptions, setInterruptions,
              selectedLanguage, handleSetSelectedLanguage,
              currentProtocol, setCurrentProtocol
            }
          }
          >
            { children }
        </GeneralContext.Provider>
    );
}
